"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableCheckCell = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var BcDataTableCheckCell = (function () {
    function BcDataTableCheckCell(bcDataTableMulticheckBehavior) {
        this.bcDataTableMulticheckBehavior = bcDataTableMulticheckBehavior;
    }
    BcDataTableCheckCell.prototype.render = function (cell) {
        var newCell = this.createTd();
        var CheckAllDivContainer = this.createDivContainer();
        var checkboxComponent = this.createCheckboxComponent(cell);
        CheckAllDivContainer.appendChild(checkboxComponent);
        newCell.appendChild(CheckAllDivContainer);
        return newCell;
    };
    BcDataTableCheckCell.prototype.createTd = function () {
        var newCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        newCell.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_MULTICHECK_TBODY_CLASS);
        return newCell;
    };
    BcDataTableCheckCell.prototype.createDivContainer = function () {
        var CheckAllDivContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        CheckAllDivContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.BODY_CHECK_DIV_CONTAINER);
        return CheckAllDivContainer;
    };
    BcDataTableCheckCell.prototype.createCheckboxComponent = function (cell) {
        var checkboxComponent = this.bcDataTableMulticheckBehavior.getTbodyCheckbox();
        if (cell.value) {
            var inputCheckbox = checkboxComponent.querySelector(common_constants_1.BcCommonConstants.INPUT_CHECKBOX_TAG);
            inputCheckbox.checked = cell.value;
        }
        checkboxComponent.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_THEAD_CLASS);
        return checkboxComponent;
    };
    return BcDataTableCheckCell;
}());
exports.BcDataTableCheckCell = BcDataTableCheckCell;
